import { render } from "./friendlySearch.vue?vue&type=template&id=2353e522"
import script from "./friendlySearch.vue?vue&type=script&lang=js"
export * from "./friendlySearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__